

import React from 'react'

function Login() {
  return (
    <>
         <section className="bg-home bg-circle-gradiant d-flex align-items-center">
            <div className="bg-overlay bg-overlay-white"></div>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-5 col-md-8"> 
                        <div className="card login-page shadow rounded border-0">
                            <div className="card-body">
                                <h4 className="card-title text-center">Нэвтрэх хуудас</h4>  
                                <form className="login-form mt-4">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="mb-3">
                                                <label className="form-label">И-мэйл хаяг <span className="text-danger">*</span></label>
                                                <div className="form-icon position-relative">
                                                    <i data-feather="user" className="fea icon-sm icons"></i>
                                                    <input type="email" className="form-control ps-5" placeholder="И-мэйл хаяг уу оруулна уу" name="email" required="" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="mb-3">
                                                <label className="form-label">Нууц үг <span className="text-danger">*</span></label>
                                                <div className="form-icon position-relative">
                                                    <i data-feather="key" className="fea icon-sm icons"></i>
                                                    <input type="password" className="form-control ps-5" placeholder="Нууц үгээ оруулна уу" required="" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="d-flex justify-content-between">
                                                
                                                <p className="forgot-pass mb-1"><a href="auth-re-password-three.html" className="text-dark fw-bold">Нууц үгээ мартсан  уу ?</a></p>
                                            </div>
                                        </div>

                                        <div className="col-lg-12 mb-0">
                                            <div className="d-grid">
                                                <button className="btn btn-primary">Нэвтрэх</button>
                                            </div>
                                        </div>

                                        {/* <div className="col-12 text-center">
                                            <p className="mb-0 mt-3"><small className="text-dark me-2">Don't have an account ?</small> <a href="auth-signup-three.html" className="text-dark fw-bold">Sign Up</a></p>
                                        </div> */}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Login